import React from 'react';
import styled from 'styled-components';

const circleGreen = 'green';
const circleGray = 'lightgray';

const ProgressBar = styled.span`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inside = styled.span`
  width: 76%;
  height: 76%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

export default ({ completed, correct }) => {
  let percentBackground;
  if (!completed) {
    percentBackground = circleGray;
  } else if (completed < 50) {
    percentBackground = `linear-gradient(90deg, ${circleGray} 50%, transparent 50%), linear-gradient(${
      completed * 3.6 + 270 // from 270 to 450
    }deg, ${circleGray} 50%, ${circleGreen} 50%)`;
  } else if (completed < 100) {
    percentBackground = `linear-gradient(270deg, ${circleGreen} 50%, transparent 50%), linear-gradient(${
      completed * 3.6 + 90 // from 270 to 450
    }deg, ${circleGreen} 50%, ${circleGray} 50%)`;
  } else {
    percentBackground = circleGreen;
  }

  return (
    <ProgressBar style={{ background: percentBackground }}>
      <Inside>{`${correct || 0}%`}</Inside>
    </ProgressBar>
  );
};



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/List/ProgressCircle.js